export enum AutomatedStatus {
  ACTION_REQUIRED = 'action_required',
  IN_PROGRESS = 'in_progress',
  COMPLETE = 'complete',
  CLOSED_ARCHIVED = 'closed_archived',
  CANCELED = 'canceled'
}
